import React from 'react'
import FJLocalStore from '../../../store/FJLocalStore'
import FJUpgradeButton from "../../../common/component/FJUpgradeButton";
import classNames from 'classnames'
import './FJPaymentLimitTip.less'
import feature from "../../../icon/feature.svg";
import InlineSVG from "react-inlinesvg";

function FJPaymentLimitTip(props) {

    const {limits, hasUpgradeBtn, upgradeText, onUpgrade} = props;
    let containerClass = classNames('c-payment-limit', {'c-payment-limit-big': hasUpgradeBtn});
    let title = FJLocalStore._('payment-limit-title-intro');
    return (
        <div className={containerClass}>
            <p className='c-payment-limit__title'>{title}</p>
            <ul className='c-payment-limit__list'>
                {
                    limits.map(function (limit) {
                        return (
                            <li key={limit} className='c-payment-limit__item'>
                                <InlineSVG src={feature} element='div' className='c-payment-limit__item_icon'/>
                                <div className='c-payment-limit__item_text'>
                                    {limit}
                                </div>
                            </li>
                        );
                    })
                }
            </ul>
            {
                hasUpgradeBtn ? <FJUpgradeButton onClick={onUpgrade} text={upgradeText} /> : null
            }
        </div>
    );
}

export default FJPaymentLimitTip;
